module.exports = __webpack_public_path__ + "img/home_pic_3.0_6.9f5eedaf.webp";